/** Small "Live" / "Reconnecting" pill for pages that sync in real time. */
export default function LiveDot({ live }: { live: boolean }) {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 text-xs text-muted-foreground"
      role="status"
      aria-live="polite"
    >
      <span
        className={`h-2 w-2 rounded-full ${live ? "bg-emerald-500" : "bg-muted-foreground/40 animate-pulse"}`}
      />
      {live ? "Live" : "Reconnecting…"}
    </span>
  );
}
